// web_tourOrder_details 订单详情

const __request = require(`./__request/__request_contentType_form`);

// 接口地址： http://192.168.0.15:8080/doc.html#/所有接口/tour-order-controller/getTourOrderUsingPOST

export default function web_tourOrder_details(pParameter) {
  if (!pParameter) pParameter = {};
  const orderId = pParameter.orderId || ''
  let params = {}
  params.method = 'POST'
  params.urlSuffix = '/web/tourOrder/details'
  params.data = {
    orderId
  }
  return new Promise(function(resolve, reject) {
    resolve(__request(params))
  })
}
